/**
 * callWechatServer模块接口列表
 */
import $http from '../utils/http'// 导入http中创建的axios实例

const callWechatServer = {
  // 获取二维码
  showQrCode (id, params) {
    let param = new URLSearchParams()
    param.append(id, params)
    return $http.get(`${global.API_URL}/sme/callWechatServer/showQrCode`, {params:param, responseType: "arraybuffer"})
  }
};

export default callWechatServer



// WEBPACK FOOTER //
// ./src/api/callWechatServer.js